import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { AccountDebitLottie } from 'Views/Page/Content/Templates/AccountDebitCommon/AccountDebitLottie';
import { AccountDebitTemplate } from 'Views/Page/Content/Templates/AccountDebitCommon/AccountDebitTemplate';
import {
  PaymentDetailRow,
} from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/PaymentInfoProfileSubpage/PaymentDetailRow';


const Layout = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <AccountDebitTemplate>
      <MetaControlField attr={'title'} />
      <AccountDebitLottie resource={resource} />
      <MetaControlField attr={'description'} />
      {resource.attr('paymentMethods') && resource.attr('paymentMethods').resources().list().map(paymentDetail => (
        <PaymentDetailRow key={paymentDetail.id()} resource={paymentDetail} />
      ))}
    </AccountDebitTemplate>
  );
};

export default Layout;
